import { Controller } from "@hotwired/stimulus";

// Toggles between the Free/Lite and Pro plan panels on the features page
export default class extends Controller {
  static targets = ["freeTab", "proTab", "freePanel", "proPanel"];

  declare readonly freeTabTarget: HTMLElement;
  declare readonly proTabTarget: HTMLElement;
  declare readonly freePanelTarget: HTMLElement;
  declare readonly proPanelTarget: HTMLElement;

  showFree() {
    this.freePanelTarget.classList.remove("hidden");
    this.proPanelTarget.classList.add("hidden");
    this.freeTabTarget.classList.add("features__switcher-btn--active");
    this.proTabTarget.classList.remove("features__switcher-btn--active");
    this.freeTabTarget.setAttribute("aria-selected", "true");
    this.proTabTarget.setAttribute("aria-selected", "false");
  }

  showPro() {
    this.proPanelTarget.classList.remove("hidden");
    this.freePanelTarget.classList.add("hidden");
    this.proTabTarget.classList.add("features__switcher-btn--active");
    this.freeTabTarget.classList.remove("features__switcher-btn--active");
    this.proTabTarget.setAttribute("aria-selected", "true");
    this.freeTabTarget.setAttribute("aria-selected", "false");
  }
}
